module.exports = __webpack_public_path__ + "static/media/error-img.0d59c075.svg";